import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Title } from 'components/layout'
import { Button } from 'components/misc'
import { apiLabels, apiCodeLists } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { updateValidate } from 'models/labels'
import { Input, Textarea } from '../../../../components/fields'
import { get } from 'lodash'

@apiLabels()
@apiCodeLists(['labelTypes'])
@form({
  form: 'update-label-form',
  disableHook: true,
  validate: updateValidate
})
class LabelUpdate extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    submitting: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onUpdateLabel: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    activeOrganization: PropTypes.object.isRequired
  }

  componentDidMount() {
    this.initForm(get(this.props, 'data'))
  }

  componentWillReceiveProps(nextProps) {
    if (get(this.props, 'data.id') !== get(nextProps, 'data.id')) {
      this.initForm(get(this.props, 'data'))
    }
  }

  initForm = data => {
    const initObj = {
      id: get(data, 'id'),
      name: get(data, 'name'),
      description: get(data, 'description'),
    }

    this.props.initialize(initObj)
  }

  render() {
    const {
      handleSubmit,
      onUpdateLabel,
      onClose,
      submitting,
      data
    } = this.props

    return (
      <Form onSubmit={handleSubmit(fields => onUpdateLabel(get(data, 'id'), fields))} >
        <Title h3 intlKey="label.update_label">
          Update label
        </Title>

        <div className="row">
          <div className="col-xs-6">
            <Input
                label="Name"
                intlKey="label.name"
                name="name"
            />
          </div>
        </div>

          <div className="row">
            <div className="col-xs-6">
              <Textarea label="Description" intlKey="label.description" name="description" />
            </div>
        </div>

        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              intlKey="button.close"
              onClick={onClose}
              secondary
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button intlKey="button.update" isLoading={submitting}>
              Update
            </Button>
          </div>
        </div>
      </Form>
    )
  }
}

export default LabelUpdate
